<div class="frt-card">
  <div class="frt-header">
    <h3 class="frt-title">Fill rate por combinación</h3>
    <p class="frt-subtitle">{{ sorted.length }} combinaciones · ordena haciendo click en los encabezados</p>
  </div>
  <div class="frt-scroll">
    <table class="frt-table">
      <thead>
        <tr>
          <th *ngFor="let col of columns" (click)="toggleSort(col.key)" class="frt-th">
            {{ col.label }}
            <span *ngIf="sortKey === col.key" class="frt-sort-arrow">{{ sortDir === 'asc' ? '▲' : '▼' }}</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of sorted" [class.frt-row--no-delivery]="row.fill_status === 'no_delivery'">
          <td class="frt-td frt-td--bold">{{ row.placement }}</td>
          <td class="frt-td">{{ row.store_type }}</td>
          <td class="frt-td">{{ safe(row.categorie_id) }}</td>
          <td class="frt-td">{{ row.ad_slot }}</td>
          <td class="frt-td">{{ row.renders_planned }}</td>
          <td class="frt-td">{{ row.renders_delivered }}</td>
          <td class="frt-td">{{ formatFillRate(row.fill_rate) }}</td>
          <td class="frt-td">
            <span class="frt-badge" [ngClass]="statusClass(row.fill_status)">
              {{ statusLabels[row.fill_status] || row.fill_status }}
            </span>
          </td>
        </tr>
        <tr *ngIf="sorted.length === 0">
          <td [attr.colspan]="columns.length" class="frt-empty">No hay combinaciones para mostrar.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
